export default {
  getBasic(state) {
    return state.basic;
  },
  getFull(state) {
    return state.full;
  },
};
